// extracted by mini-css-extract-plugin
export default {"RelatedJobs__link":"_3czWiA3a","relatedJobsLink":"_3czWiA3a","RelatedJobs__title":"_1rORhReY","relatedJobsTitle":"_1rORhReY"};